'use strict';
import React from 'react';
import _ from 'lodash';

/**
 * A list of breadcrumbs links.
 *
 * @extends {React.Component}
 */
class PageHeaderNavigation extends React.Component {

  renderNavigationSlash () {
    const uniqueKey = _.uniqueId('pageHeaderNavSlash');
    return <span key={uniqueKey} className="PageHeader-navigationSlash"></span>;
  }

  renderPageNavigationOptions () {
    const children = this.props.children,
          childrenCount = React.Children.count(children);
    const navigationMenu = [];

    if (childrenCount > 0) {
      React.Children.forEach(children, (child, index) => {
        navigationMenu.push(child);
        if (index < children.length - 1) {
          navigationMenu.push(this.renderNavigationSlash())
        }
      });
    }
    return navigationMenu;
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    return (
      <div className="PageHeader-navigation">
        { this.renderPageNavigationOptions() }
      </div>
    );
  }
}

export default PageHeaderNavigation;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/pageHeader/pageHeaderNavigation.jsx